'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { getProductPriceDisplay } from '@eliadmin/core/src/utils/product-price-utils';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { FerviAvailability } from '../fervi-availability';
import { getFerviAvailability } from '../../../utils/fervi-availability';

export function ProductTags({ product }: { product: ProductDetailData }) {
  const selectedVariant = useVariantsStore(s => s.selectedVariant);

  const desiredObject = product.variants?.length ? selectedVariant : product;
  const isWholesaler = useCustomerStore(state => state.me?.customer.is_wholesaler);
  const priceDisplay = getProductPriceDisplay(desiredObject ?? product, { isWholesaler });
  const showDeliveryDays = useGlobalStore(
    s => s.templateSettings.product_detail?.show_availability_delivery_days?.enabled,
  );
  const displayedAvailability = desiredObject
    ? getFerviAvailability(
        desiredObject.availability,
        desiredObject.unavailability,
        desiredObject.quantity,
        product.min_quantity || 1,
      )
    : null;

  const { t } = useTranslations();

  return (
    <div className="flex flex-wrap items-start justify-start gap-2">
      <FerviAvailability availability={displayedAvailability} showDeliveryDays={showDeliveryDays} />
      {priceDisplay.showPreviousPrice && (
        <div className="flex h-[36px] items-center justify-start gap-2 rounded-full bg-[#FFD3D1] px-3">
          <Image
            src={'/images/icons/sale.svg'}
            alt=""
            width={24}
            height={24}
          />
          <p className="text-sm font-normal capitalize text-[#B80900]">
            {t('text24')} -{priceDisplay.discountLabel}%
          </p>
        </div>
      )}
    </div>
  );
}
